__turbopack_context__.v({
  "gradientSphere": "BackgroundLights-module__hJS_TW__gradientSphere",
  "main": "BackgroundLights-module__hJS_TW__main",
});
